"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Chip_1 = require("@material-ui/core/Chip");
var React = require("react");
var configs_1 = require("../configs");
var utils_1 = require("../utils");
var InsertableFieldChips = function (props) {
    var appendInsertableToFocusedInput = function (insertableName) {
        var inputElement = document.getElementById(props.inputId);
        var selectionStartIndex = inputElement.selectionStart;
        //If something is highlighted within the input, delete it first before continuing
        if (inputElement.selectionStart != inputElement.selectionEnd) {
            inputElement.value = utils_1.spliceOutOfString(inputElement.value, inputElement.selectionStart, inputElement.selectionEnd - inputElement.selectionStart);
        }
        var insertionWithDelimeters = configs_1.defaultInsertableDelimiters.startDelimiter + insertableName + configs_1.defaultInsertableDelimiters.endDelimiter;
        props.setInput(props.inputId, utils_1.insertIntoString(inputElement.value, insertionWithDelimeters, selectionStartIndex));
        inputElement.focus();
        inputElement.setSelectionRange(selectionStartIndex + insertionWithDelimeters.length, selectionStartIndex + insertionWithDelimeters.length);
    };
    var chips = props.insertableFieldNames.map(function (name, index) {
        return React.createElement(Chip_1.default, { key: index, style: { marginRight: "3px" }, disabled: props.disabled, onClick: function () { }, label: props.labels[index], onMouseDown: function (e) { e.preventDefault(); appendInsertableToFocusedInput(name); } });
    });
    return (React.createElement(React.Fragment, null, chips));
};
exports.default = InsertableFieldChips;
//# sourceMappingURL=InsertableFieldChips.js.map